// Shared by method finder, method details and the personal workspace.
export async function startPersonalMethod(button) {
    const root = button.closest('[data-personal-workspace-base]');
    const method = Number(button.dataset.personalMethod);
    if (!root || !Number.isSafeInteger(method) || method <= 0 || button.disabled) return;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    const errorElement = button.parentNode.querySelector('[data-personal-workspace-error-message]');
    if (errorElement) errorElement.textContent = '';
    let failureMessage = root.dataset.personalWorkspaceError;
    try {
        // Keep the same key on a failed request so manual retries cannot duplicate a saved draft.
        button.dataset.personalCreationKey ||= crypto.randomUUID();
        const endpoint = root.dataset.personalWorkspaceBase.replace(/\/$/, '') + '/methods/' + method + '/results';
        const response = await fetch(endpoint, {
            method: 'POST', credentials: 'same-origin',
            headers: {Accept: 'application/json', 'Content-Type': 'application/json', Authorization: 'Bearer ' + root.dataset.personalWorkspaceToken},
            body: JSON.stringify({idempotency_key: button.dataset.personalCreationKey}),
        });
        const payload = await response.json();
        if (!response.ok || payload.ok === false) { failureMessage = payload.message || failureMessage; throw new Error(); }
        const result = payload.data || payload;
        if (!Number.isSafeInteger(result.result_id) || result.result_id <= 0) throw new Error(root.dataset.personalWorkspaceError);
        const target = new URL(root.dataset.personalWorkspaceUrl, window.location.origin);
        target.searchParams.set('result_id', String(result.result_id));
        window.location.assign(target.toString());
    } catch (error) {
        let message = errorElement;
        if (!message) {
            message = document.createElement('p');
            message.setAttribute('data-personal-workspace-error-message', '');
            message.setAttribute('role', 'alert');
            button.parentNode.appendChild(message);
        }
        message.textContent = failureMessage;
        button.disabled = false;
        button.removeAttribute('aria-busy');
    }
}

if (typeof document !== 'undefined') document.addEventListener('click', event => {
    const button = event.target.closest('[data-personal-method]');
    if (button) { event.preventDefault(); startPersonalMethod(button); }
});
